import {connect} from "react-redux";
import ValetOpportunityList from "./list";
import {bindActionCreators} from "redux";
import {getOpportunityFilter, list} from "../../../../service/Opportunities/action";
const mapStateToProps = (state) => ({
    opportunityList:state.Opportunitie.opportunityList,
    getFilterContent:state.Opportunitie.getFilterContent,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            list,
            getOpportunityFilter,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ValetOpportunityList);
